module.exports = __webpack_public_path__ + "static/media/redemption-gift-bag.c0642e6e.png";